import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withFirebase } from 'react-redux-firebase';
import Formsy from 'formsy-react';

import './OrganizationsContentDetails.css';

import Input from '../../components/Formsy/Input';

import OrganizationsContentDetailsRemoveBtn from '../OrganizationsContentDetailsRemoveBtn';
import AddIcon from '../UIKit/AddIcon';
import RemoveIcon from '../UIKit/RemoveIcon/RemoveIcon';

class DetailsForm extends Component {
  static genEmptyDetailObj() {
    return {
      key: '',
      value: '',
    };
  }

  async addDetail(index) {
    const { details } = this.props;
    const pre = details.slice(0, index + 1);
    const current = DetailsForm.genEmptyDetailObj();
    const post = details.slice(index + 1);

    const { firebase, organization: { id } } = this.props;

    try {
      await firebase.set(`/organizations/${id}/details`, [...pre, current, ...post]);
    } catch (e) {
      console.error(e);
    }
  }

  async removeDetail(index) {
    const { details } = this.props;
    const pre = details.slice(0, index);
    const post = details.slice(index + 1);

    const { firebase, organization: { id } } = this.props;

    try {
      await firebase.set(`/organizations/${id}/details`, [...pre, ...post]);
    } catch (e) {
      console.error(e);
    }
  }

  handleAddClick(e, index) {
    e.preventDefault();

    this.addDetail(index);
  }

  handleRemoveClick(e, index) {
    e.preventDefault();

    this.removeDetail(index);
  };

  renderInputs() {
    const { isOwner, details } = this.props;

    const style = {
      color: '#000',
      backgroundColor: '#fff',
      margin: 0,
      wrapper: {
        margin: 0,
      },
    };

    return details.map(({ key, value }, index, array) => {
      if (isOwner !== true) {
        return (
          <div className="DetailsForm__container" key={`${value}${index}`}>
            {key}: {value}
          </div>
        );
      }

      return (
        <div className="DetailsForm__container" key={`${value}${index}`}>
          <div className="DetailsForm__container__input">
            <Input
              name={`key.${index}`}
              style={style}
              className="DetailsForm__container__input__input"
              placeholder="Enter type here..."
              value={key}
            />
          </div>
          <div className="DetailsForm__container__input">
            <Input
              name={`value.${index}`}
              style={style}
              className="DetailsForm__container__input__input"
              placeholder="Enter value here..."
              value={value}
            />
          </div>
          <div className="DetailsForm__container__input__remove" onClick={(e) => {
            this.handleRemoveClick(e, index);
          }}>
            <RemoveIcon />
          </div>
          <div className="DetailsForm__container__input__add">
            <button
              className={[
                'DetailsForm__container__input__add__button',
                index === array.length - 1 && 'DetailsForm__container__input__add__button--last',
              ].filter(className => className).join(' ')}
              onClick={(e) => {
                this.handleAddClick(e, index);
              }}
            >
              <AddIcon className="DetailsForm__container__input__add__button__icon" />
            </button>
          </div>
        </div>
      );
    });
  }

  genNewDetailsFromForm({ key, value }) {
    const keys = Object.keys(key);
    const values = Object.keys(value);

    return keys.map(index => ({
      key: key[keys[index]],
      value: value[values[index]],
    }));
  }

  async updateDetails(model) {
    const newDetails = this.genNewDetailsFromForm(model);
    const { firebase, organization: { id } } = this.props;

    try {
      await firebase.set(`/organizations/${id}/details`, newDetails);
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { isOwner, details } = this.props;

    return (
      <Formsy
        ref="form"
        onSubmit={(...params) => {
          this.updateDetails(...params);
        }}
      >
        {this.renderInputs()}
        {isOwner && details.length > 0 && <div className="OrganizationsContentDetails__box__content__button">
          <button
            className="OrganizationsContentDetails__box__content__button__button"
            type="submit"
          >
            SAVE DETAILS
          </button>
        </div>}
        {isOwner && details.length === 0 && <div className="OrganizationsContentDetails__box__content__button">
          <button
            className="OrganizationsContentDetails__box__content__button__button"
            type="button"
            onClick={(e) => {
              this.handleAddClick(e);
            }}
          >
            ADD SOME DETAILS
          </button>
        </div>}
      </Formsy>
    );
  }
}

class NameForm extends Component {
  async updateName({ name }) {
    const { firebase, organization: { id } } = this.props;

    try {
      await firebase.set(`/organizations/${id}/name`, name);
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { organization, isOwner } = this.props;

    const style = {
      color: '#000',
      backgroundColor: '#fff',
      margin: 0,
      wrapper: {
        margin: '0 0 10px',
      },
    };

    let nameElem = (
      <div>
        {organization.name}
      </div>
    );

    if (isOwner) {
      nameElem = (
        <Input
          name="name"
          className="OrganizationsContentDetails__box__content__input__input"
          label="Organization name"
          value={organization.name}
          style={style}
          required
          autoComplete="off"
        />
      );
    }

    return (
      <Formsy
        onSubmit={(...params) => {
          this.updateName(...params);
        }}
      >
        <div className="OrganizationsContentDetails__box__content__input">
          {nameElem}
        </div>
        {isOwner && <div className="OrganizationsContentDetails__box__content__button">
          <button
            className="OrganizationsContentDetails__box__content__button__button"
            type="submit"
          >
            SAVE NAME
          </button>
        </div>}
      </Formsy>
    );
  }
}

class OrganizationsContentDetails extends Component {
  static DetailsForm = DetailsForm;
  static NameForm = NameForm;

  render() {
    const { isOwner, details } = this.props;

    return (
      <div className="OrganizationsContentDetails">
        <div className="OrganizationsContentDetails__box">
          <h2 className="OrganizationsContentDetails__box__header">Organization name</h2>
          <div className="OrganizationsContentDetails__box__content">
            <NameForm {...this.props} />
          </div>
        </div>
        <div className="OrganizationsContentDetails__box">
          <h2 className="OrganizationsContentDetails__box__header">Organization details</h2>
          <div className="OrganizationsContentDetails__box__content">
            { details.length === 0 && (
              <div>
                There are no details yet.
              </div>
            )}
            <DetailsForm {...this.props} />
          </div>
        </div>
        {isOwner === true && (
          <div className="OrganizationsContentDetails__box">
            <OrganizationsContentDetailsRemoveBtn/>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ firebase }, { match }) => {
  const organization = firebase.data.organizations[match.params.organizationId];
  const isOwner = Object.keys(organization.owners).reduce((acc, curr) => {
    if (organization.owners[curr] === true && curr === firebase.auth.uid) {
      return true;
    }

    return acc;
  }, false);

  return {
    organization,
    isOwner,
    details: organization.details || [],
  };
};

export default compose(withFirebase, connect(mapStateToProps))(OrganizationsContentDetails);



// WEBPACK FOOTER //
// ./src/components/OrganizationsContentDetails/OrganizationsContentDetails.jsx